module.exports = __webpack_public_path__ + "img/combate.b6497358.png";